import React from "react";
import MaterializeWizard from "./MaterializeWizard.tsx/MaterializeWizard";

const NewMaterialize = () => {
  return <MaterializeWizard materializationConfig={null} />;
};

export default NewMaterialize;
